(ns manage.ad-variant-preview.widgets.image-preview
  (:require [manage.ad-variant-preview.widgets.component-error :refer [component-error]]
            [manage.ad-variant-preview.widgets.loading-spinner :refer [loading-spinner]]
            [uix.core :as uix :refer [$ defui]]))

(defui image-preview [{:keys [width height component]}]
  (let [{:keys [error pending value]} component]
    (cond
      error
      ($ component-error
         {:width width
          :height height})

      pending
      ($ loading-spinner
         {:width width
          :height height})

      :else
      ($ :img
         {:src value
          :width width
          :height height}))))
